import { useState } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysOrderPurchaseDetailPurMaterialRegisterDialog from "../dialogTypes/MomSysOrderPurchaseDetailPurMaterialRegisterDialog";

function MomSysOrderPurchaseDetailPurMaterialRegisterButton(props) {
    const {
        id,
        schema,
        onSuccess,
        customizeErrorMsgCallback,
        onDialogUpdateDetail,
        orderPurchaseMstSelect,
        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-pur-material-register-button"}
                onClick={onOpen}
                createButtonName={"orderPurchaseDetailPurMaterialRegister"}
                {...others}
            />
            <MomSysOrderPurchaseDetailPurMaterialRegisterDialog
                id={id + "-pur-material-register-dialog"}
                mode="create"
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                onDialogUpdateDetail={onDialogUpdateDetail}
                orderPurchaseMstSelect={orderPurchaseMstSelect}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default MomSysOrderPurchaseDetailPurMaterialRegisterButton;
